import React from "react";
import styles from "./Download.module.sass";
import Hero from "./Hero";
import Platform from "./Platform";
import Community from "../../components/Community";

const Download = () => {
  return (
    <>
      <Hero />
      <Platform />
      <Community />
    </>
  );
};

export default Download;
